import React from 'react';
import { Button } from './Button';
import { CheckIcon } from 'lucide-react';
export const ValueStackSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-900 to-teal-800 text-white py-16" data-id="element-352">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-353">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-354">
          What You Get When You Sign Up Today
        </h2>
        <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-lg mb-8 max-w-2xl mx-auto" data-id="element-355">
          <div className="space-y-4" data-id="element-356">
            <div className="flex items-center" data-id="element-357">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-358" />
              <div data-id="element-359">
                <span className="font-bold text-lg" data-id="element-360">30-Day Guided Program</span>
                <span className="text-teal-200 ml-2" data-id="element-361">— $70</span>
              </div>
            </div>
            <div className="flex items-center" data-id="element-362">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-363" />
              <div data-id="element-364">
                <span className="font-bold text-lg" data-id="element-365">
                  60+ Nervous System Somatic Tools
                </span>
                <span className="text-teal-200 ml-2" data-id="element-366">— $39</span>
              </div>
            </div>
            <div className="flex items-center" data-id="element-367">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-368" />
              <div data-id="element-369">
                <span className="font-bold text-lg" data-id="element-370">
                  Deep-Dive Therapist Lessons
                </span>
                <span className="text-teal-200 ml-2" data-id="element-371">— $29</span>
              </div>
            </div>
            <div className="flex items-center" data-id="element-372">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-373" />
              <div data-id="element-374">
                <span className="font-bold text-lg" data-id="element-375">Lifetime Access</span>
                <span className="text-teal-200 ml-2" data-id="element-376">— $49</span>
              </div>
            </div>
            <div className="border-t border-teal-600 pt-4 mt-4" data-id="element-377">
              <div className="flex items-center justify-between" data-id="element-378">
                <span className="font-bold text-lg" data-id="element-379">Total Value:</span>
                <span className="font-bold text-lg" data-id="element-380">$187</span>
              </div>
            </div>
            <div className="bg-teal-600 p-4 rounded-lg relative" data-id="element-381">
              <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-382">
                LIMITED TIME
              </div>
              <div className="flex items-center justify-between" data-id="element-383">
                <span className="font-bold text-lg" data-id="element-384">Today Only:</span>
                <span className="font-bold text-2xl" data-id="element-385">$29</span>
              </div>
              <div className="text-center mt-1 text-white" data-id="element-386">
                One-Time Payment
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-387">
          <Button link={checkoutUrl} data-id="element-388">Start My Reset – Just $29 ➔</Button>
        </div>
      </div>
    </section>;
};